export default {
  'UserSection.viewProfile': { en: 'View Profile', fr: 'Voir le profil' },
};
